// extracted by mini-css-extract-plugin
module.exports = {"footer":"Pagination_footer__XGAhb","paginationButton":"Pagination_paginationButton__3-Xh2"};